import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState, AppThunk } from "../../app/store";
import { fetchRoleListData } from "./rolebaseAPI";
export interface RoleListState {
  roleListData: Array<any>;
  status: "idle" | "loading" | "failed" | "success";
}

const initialState: RoleListState = {
  roleListData: [],
  status: "idle",
};

export const GetRoleListData = createAsyncThunk("RoleList/fetchRoleListData", async () => {
  const response = await fetchRoleListData();
  return response;
});

export const RoleListSlice = createSlice({
  name: "RoleList",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(GetRoleListData.pending, (state) => {
        state.status = "loading";
      })
      .addCase(GetRoleListData.rejected, (state) => {
        state.status = "failed";
      })
      .addCase(GetRoleListData.fulfilled, (state, action) => {
        state.status = "success";
        state.roleListData = action.payload;
      });
  },
});

export const {} = RoleListSlice.actions;

export const selectRoleListData = (state: RootState) => {
  return state.RoleList.roleListData;
};

export default RoleListSlice.reducer;
